import type { BuildDetalhe } from '@/data/types';

/**
 * Barramento mínimo de "algo mudou" entre telas montadas ao mesmo tempo.
 *
 * O detalhe da versão abre num Sheet por cima do feed (ou da fila de
 * homologação): quando ele muda o status ou publica no painel, a lista atrás
 * precisa refletir sem recarregar tudo. Em vez de amarrar callbacks por props
 * através de três telas, quem escreve emite e quem lista escuta.
 */

export type EventoCompilacoes =
  | { tipo: 'build'; build: BuildDetalhe }
  | { tipo: 'painel'; versao: string }
  /** Incidente criado/editado/apagado ou com versões (des)associadas: `versoes` são todas as que ele afeta ou afetava. */
  | { tipo: 'incidente'; id: number; versoes: string[] };

const ouvintes = new Set<(evento: EventoCompilacoes) => void>();

export function emitir(evento: EventoCompilacoes): void {
  ouvintes.forEach((ouvinte) => ouvinte(evento));
}

export function ouvir(ouvinte: (evento: EventoCompilacoes) => void): () => void {
  ouvintes.add(ouvinte);
  return () => ouvintes.delete(ouvinte);
}
